import { render, staticRenderFns } from "./OnSiteAttendence.vue?vue&type=template&id=197b80d2&scoped=true"
import script from "./OnSiteAttendence.vue?vue&type=script&lang=js"
export * from "./OnSiteAttendence.vue?vue&type=script&lang=js"
import style0 from "./OnSiteAttendence.vue?vue&type=style&index=0&id=197b80d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b80d2",
  null
  
)

export default component.exports